/* TRAMA — interactividad propia (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.tr-reveal:not(.tr-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('tr-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('tr-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCifras(root) {
    var els = (root || document).querySelectorAll('[data-tr-contar]');
    if (!els.length) return;
    function animar(el) {
      var fin = parseFloat(el.getAttribute('data-tr-contar')) || 0;
      var dur = parseInt(el.getAttribute('data-tr-duracion'), 10) || 1600;
      if (reduce) { el.textContent = fin; return; }
      var t0 = null;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        el.textContent = Math.round(fin * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(animar); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initInterruptor(root) {
    (root || document).querySelectorAll('.tr-enciende').forEach(function (sec) {
      var btn = sec.querySelector('.tr-interruptor');
      if (!btn || btn.dataset.trListo) return;
      btn.dataset.trListo = '1';
      btn.addEventListener('click', function () {
        var on = sec.classList.toggle('tr-on');
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (sec.dataset.trAuto === 'true' && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              setTimeout(function () { sec.classList.add('tr-on'); btn.setAttribute('aria-pressed', 'true'); }, 900);
              io.disconnect();
            }
          });
        }, { threshold: 0.55 });
        io.observe(sec);
      }
    });
  }

  function initGaleria(root) {
    (root || document).querySelectorAll('.tr-galeria').forEach(function (g) {
      var principal = g.querySelector('.tr-galeria__principal img');
      var botones = g.querySelectorAll('.tr-galeria__miniaturas button:not([data-tr-3d]):not([data-tr-ver-vid])');
      if (!principal || !botones.length) return;
      botones.forEach(function (b) {
        b.addEventListener('click', function () {
          botones.forEach(function (x) { x.classList.remove('tr-activa'); });
          b.classList.add('tr-activa');
          principal.style.opacity = '0';
          setTimeout(function () {
            principal.src = b.getAttribute('data-src');
            principal.removeAttribute('srcset');
            principal.alt = b.getAttribute('data-alt') || '';
            principal.style.opacity = '1';
          }, 180);
        });
      });
    });
  }

  function initCompra(root) {
    (root || document).querySelectorAll('.tr-compra').forEach(function (c) {
      var datos = c.querySelector('script[data-tr-variantes]');
      var input = c.querySelector('input[name="id"]');
      var boton = c.querySelector('button[name="add"]');
      var precio = c.querySelector('.tr-precio');
      var tachado = c.querySelector('.tr-precio-tachado');
      var cant = c.querySelector('.tr-cantidad input');
      c.querySelectorAll('.tr-cantidad button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(cant.value, 10) || 1;
          cant.value = Math.max(1, v + (b.dataset.paso === 'mas' ? 1 : -1));
        });
      });
      if (!datos || !input) return;
      var variantes = JSON.parse(datos.textContent);
      var formato = c.getAttribute('data-tr-moneda') || '{{amount_with_comma_separator}} €';
      function dinero(cent) {
        var n = (cent / 100).toFixed(2).replace('.', ',');
        return formato.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n);
      }
      c.querySelectorAll('.tr-compra__opcion input').forEach(function (r) {
        r.addEventListener('change', function () {
          var sel = [];
          c.querySelectorAll('.tr-compra__opcion').forEach(function (fs) {
            var ch = fs.querySelector('input:checked');
            sel.push(ch ? ch.value : null);
          });
          var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
          if (!v) { boton.disabled = true; boton.querySelector('span').textContent = boton.dataset.noDisponible; return; }
          input.value = v.id;
          if (precio) precio.textContent = dinero(v.price);
          if (tachado) { tachado.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : ''; }
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? boton.dataset.texto : boton.dataset.agotado;
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        });
      });
    });
  }

  function initTodo(root) {
    initReveal(root); initCifras(root); initInterruptor(root); initGaleria(root); initCompra(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  else initTodo();

  /* Editor de Shopify: re-inicializar al añadir/editar secciones */
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();

/* Colores elegidos (muestra el nombre junto al título) y mensaje emergente */
(function () {
  function initColores(root) {
    (root || document).querySelectorAll('.tr-colores').forEach(function (fs) {
      var out = fs.querySelector('.tr-colores__elegido');
      function pinta() { var ch = fs.querySelector('input:checked'); if (out) out.textContent = ch ? ch.value : ''; }
      fs.addEventListener('change', pinta); pinta();
    });
  }
  function initPopup(root) {
    (root || document).querySelectorAll('.tr-popup').forEach(function (p) {
      if (p.dataset.trListo) return; p.dataset.trListo = '1';
      var clave = 'tr-popup-' + (p.dataset.version || '1');
      var dias = parseInt(p.dataset.dias, 10) || 3;
      var enEditor = window.Shopify && Shopify.designMode;
      function cerrar() {
        p.classList.remove('tr-abierto');
        try { localStorage.setItem(clave, String(Date.now())); } catch (e) {}
      }
      p.querySelectorAll('[data-tr-cerrar]').forEach(function (b) { b.addEventListener('click', cerrar); });
      p.addEventListener('click', function (e) { if (e.target === p) cerrar(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrar(); });
      if (enEditor) { if (p.dataset.verEditor === 'true') p.classList.add('tr-abierto'); return; }
      var visto = 0;
      try { visto = parseInt(localStorage.getItem(clave), 10) || 0; } catch (e) {}
      if (visto && Date.now() - visto < dias * 86400000) return;
      setTimeout(function () { p.classList.add('tr-abierto'); }, (parseInt(p.dataset.retraso, 10) || 4) * 1000);
    });
  }
  function init(root) { initColores(root); initPopup(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Visor 3D: cambiar entre 3D y fotos, y pintar pantalla/base con los colores elegidos */
(function () {
  function hexARgb(h) {
    h = (h || '').replace('#', '');
    if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join('');
    var n = parseInt(h, 16); if (isNaN(n)) return null;
    // model-viewer trabaja en color lineal: convertimos desde sRGB
    return [n >> 16 & 255, n >> 8 & 255, n & 255].map(function (c) { c /= 255; return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); }).concat(1);
  }
  function initVisor(root) {
    (root || document).querySelectorAll('.tr-producto').forEach(function (sec) {
      var visor = sec.querySelector('.tr-galeria__visor');
      var mv = sec.querySelector('model-viewer.tr-visor');
      if (!visor || !mv || mv.dataset.trListo) return; mv.dataset.trListo = '1';
      var principal = sec.querySelector('.tr-galeria__principal');
      var botones = sec.querySelectorAll('.tr-galeria__miniaturas button');
      botones.forEach(function (b) {
        b.addEventListener('click', function () {
          var es3d = b.hasAttribute('data-tr-3d');
          botones.forEach(function (x) { x.classList.toggle('tr-activa', x === b); });
          visor.hidden = !es3d; if (principal) principal.hidden = es3d;
        });
      });
      function pintar() {
        if (!mv.model) return;
        sec.querySelectorAll('.tr-colores input:checked').forEach(function (inp) {
          var mat = mv.model.materials.find(function (m) { return m.name === inp.dataset.trPieza; });
          var rgb = hexARgb(inp.dataset.trHex);
          if (mat && rgb) mat.pbrMetallicRoughness.setBaseColorFactor(rgb);
        });
      }
      mv.addEventListener('load', pintar);
      sec.querySelectorAll('.tr-colores').forEach(function (fs) { fs.addEventListener('change', pintar); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initVisor(); }); else initVisor();
  document.addEventListener('shopify:section:load', function (e) { initVisor(e.target); });
})();

/* Vídeo de portada: asegurar reproducción automática (algunos móviles la retrasan) */
(function () {
  function arrancar() {
    document.querySelectorAll('video.tr-hero__video').forEach(function (v) {
      v.muted = true; v.setAttribute('muted', ''); v.playsInline = true;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
  document.addEventListener('visibilitychange', function () { if (!document.hidden) arrancar(); });
  document.addEventListener('touchstart', arrancar, { once: true, passive: true });
})();

/* Galería: miniaturas de vídeo + extra opcional al añadir a la cesta */
(function () {
  function initVideosGaleria(root) {
    (root || document).querySelectorAll('.tr-galeria').forEach(function (g) {
      var botones = g.querySelectorAll('.tr-galeria__miniaturas button');
      var vids = g.querySelectorAll('.tr-galeria__vid');
      var principal = g.querySelector('.tr-galeria__principal');
      var visor = g.querySelector('.tr-galeria__visor');
      if (!vids.length || g.dataset.trVidListo) return; g.dataset.trVidListo = '1';
      function ocultarVideos() { vids.forEach(function (v) { v.hidden = true; var e = v.querySelector('video'); if (e) e.pause(); }); }
      botones.forEach(function (b) {
        b.addEventListener('click', function () {
          var n = b.getAttribute('data-tr-ver-vid');
          ocultarVideos();
          if (n === null) return; // foto o 3D: lo gestionan los otros scripts
          botones.forEach(function (x) { x.classList.toggle('tr-activa', x === b); });
          if (principal) principal.hidden = true;
          if (visor) visor.hidden = true;
          var c = g.querySelector('[data-tr-vid="' + n + '"]'); c.hidden = false;
          var e = c.querySelector('video'); if (e) { e.muted = true; var p = e.play(); if (p && p.catch) p.catch(function () {}); }
        });
      });
      // al volver a una foto, asegurar que la foto se ve
      botones.forEach(function (b) {
        if (b.hasAttribute('data-tr-ver-vid') || b.hasAttribute('data-tr-3d')) return;
        b.addEventListener('click', function () { if (principal) principal.hidden = false; if (visor) visor.hidden = true; });
      });
    });
  }
  function initExtra(root) {
    (root || document).querySelectorAll('form.tr-compra__formulario').forEach(function (f) {
      var check = f.querySelector('.tr-extra__check');
      if (!check || f.dataset.trExtraListo) return; f.dataset.trExtraListo = '1';
      f.addEventListener('submit', function (ev) {
        if (!check.checked) return;
        ev.preventDefault();
        var fd = new FormData(f), cant = parseInt(fd.get('quantity'), 10) || 1, props = {};
        fd.forEach(function (val, k) { var m = k.match(/^properties\[(.+)\]$/); if (m) props[m[1]] = val; });
        var titulo = (document.querySelector('.tr-compra__titulo') || {}).textContent || '';
        var items = [
          { id: fd.get('id'), quantity: cant, properties: props },
          { id: check.getAttribute('data-tr-extra'), quantity: cant, properties: { 'Para la lámpara': titulo.trim() } }
        ];
        var btn = f.querySelector('button[name="add"]'); if (btn) btn.disabled = true;
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items })
        }).then(function (r) { if (!r.ok) throw r; window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; })
          .catch(function () { if (btn) btn.disabled = false; f.submit(); });
      });
    });
  }
  function init(root) { initVideosGaleria(root); initExtra(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
